export function tokenGetter() {
    return localStorage.getItem('id_token');
}
